export default __webpack_public_path__ + "static/media/ic-openMode-dark-off.b6ee6747.svg";